import { gql } from '@apollo/client';

const GET_TERMS_AND_CONDITIONS_TEMPLATE = gql`
  query termsAndConditionsTemplateHTML {
    termsAndConditionsTemplateHTML
  }
`;

const POST_TERMS_AND_CONDITIONS = gql`
  mutation createTermsAndConditions {
    createTermsAndConditions {
      termsAndConditionsId
      templateId
      createdAt
      accepted
    }
  }
`;

const GET_CONCESSIONAIRE_TERMS_AND_CONDITIONS = gql`
  query concessionaireTermsAndConditionsFile {
    concessionaireTermsAndConditionsFile {
      fileId
      filename
      url
    }
  }
`;

const termsAndConditionsOperations = {
  GET_CONCESSIONAIRE_TERMS_AND_CONDITIONS,
  GET_TERMS_AND_CONDITIONS_TEMPLATE,
  POST_TERMS_AND_CONDITIONS,
};

export default termsAndConditionsOperations;
